import { simpleSet } from '@r/reducers/utils';

const setCalculationModeMarkupLabel = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.materials.markup.label;

export const label = setCalculationModeMarkupLabel(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_MARKUP_LABEL',
  ''
);
